<template>
    <footer v-if="!isStorePage" class="bg-black-700 w-full mt-auto flex justify-center items-center md:justify-evenly flex-col md:flex-row gap-8 p-8">
        <div class="text-black-100 flex justify-center items-center gap-8">
            <!-- <router-link to="/contact" class="socialIcon hover:text-gray-300 transition-colors">
                <i class="fa-solid fa-envelope"></i>
            </router-link> -->
            <a href="http://instagram.com/facecage.co" target="_blank">
                <i class="fa-brands fa-instagram socialIcon"></i>
            </a>
            <a href="https://www.youtube.com/@facecageco" target="_blank">
                <i class="fa-brands fa-youtube socialIcon"></i>
            </a>
        </div>
        <div class="text-black-100 text-sm flex justify-center items-center">
            {{ $t('footer.copyright', { year: currentYear }) }}
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    },
    computed: {
        isStorePage() {
            return this.$route.path === '/store';
        }
    }
}
</script>